var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChinaFlag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 45,
    height: 32,
    viewBox: "0 0 45 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "china-flag") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#d80027",
    d: "M0 0h44.72v32h-44.72v-32z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffda44",
    d: "M15.576 9.772l1.374 4.228h4.446l-3.6 2.614 1.374 4.228-3.6-2.614-3.6 2.614 1.374-4.228-3.6-2.614h4.446z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffda44",
    d: "M24.238 23.836l-1.35-0.98-1.348 0.98 0.516-1.586-1.348-0.98h1.668l0.516-1.586 0.516 1.586h1.668l-1.348 0.98z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffda44",
    d: "M27.756 18.994h-1.668l-0.516 1.586-0.516-1.586h-1.668l1.35-0.98-0.516-1.586 1.348 0.98 1.348-0.98-0.516 1.586z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffda44",
    d: "M27.756 13.006l-1.348 0.98 0.516 1.586-1.348-0.98-1.348 0.98 0.516-1.586-1.35-0.98h1.668l0.516-1.586 0.516 1.586z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffda44",
    d: "M24.238 8.17l-0.516 1.586 1.348 0.98h-1.668l-0.516 1.586-0.516-1.586h-1.668l1.348-0.98-0.516-1.586 1.348 0.98z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChinaFlag);
export default __webpack_public_path__ + "static/media/china-flag.e4a15f28c88e5704924ccca3109346e5.svg";
export { ForwardRef as ReactComponent };